// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"styles_headerWrapper__7KiWi","mainHeader":"styles_mainHeader__NBWvn","headerMenu":"styles_headerMenu__jCsW0"};